// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"168":"b481990f","392":"44bfe209","852":"5d21ff5b"}[chunkId] + ".chunk.js";
};